export interface ISnVideo {
  frameRate: {
    [name: string]: {
      label: string;
      value: number;
    };
  };
  optimalBitrate: {
    [name: string]: {
      [name: string]: {
        [name: string]: {
          label: string;
          value: number;
          isDefault?: boolean;
        };
      };
    };
  };
  optimalKeyframe: {
    [name: string]: {
      [name: string]: {
        label: string;
        value: number;
        isDefault?: boolean;
      };
    };
  };
  resolution: {
    [name: string]: {
      label: string;
      width: number;
      height: number;
    };
  };
}
